import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticBlocks = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findBlocksSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useBlocksQuery {
		squidex {
			findBlocksSingleton {
				id
				data {
					introTitle {
						de
					}
					introText {
						de
					}

					portalTitle {
						de
					}
					portalText {
						de
					}

					developTitle {
						de
					}
					developText {
						de
					}

					constructTitle {
						de
					}
					constructText {
						de
					}
				}
			}
		}
	}
`;
